module.exports = __webpack_public_path__ + "static/img/field_hof.8bb9852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/field_hof.png
// module id = FT0K
// module chunks = 1